import { Inject, Injectable } from '@angular/core';
import {
  DwOrmDataService,
  DwOrmDataServiceToken
} from '@devwareapps/devware-cap';
import { forkJoin, Observable } from 'rxjs';
import {
  AppMetaData,
  UnitMemberQualificationOptionEntity,
  UnitMemberQualificationResponseEntity,
  UnitMemberQualificationTypeEntity
} from '../../../meta-data/app-meta-data.service';

export interface UnitMemberQualificationData {
  definitions: UnitMemberQualificationTypeEntity[];
  options: UnitMemberQualificationOptionEntity[];
  responses: UnitMemberQualificationResponseEntity[];
}

@Injectable({ providedIn: 'root' })
export class UnitMemberQualificationRepositoryService {
  private readonly activeReferenceStatusId = 1;

  constructor(
    @Inject(DwOrmDataServiceToken) private dwOrmDataService: DwOrmDataService
  ) { }

  load(flightSchoolExaminerId: number): Observable<UnitMemberQualificationData> {
    return forkJoin({
      definitions: this.loadDefinitions(),
      options: this.loadOptions(),
      responses: this.loadResponses(flightSchoolExaminerId)
    });
  }

  save(responses: UnitMemberQualificationResponseEntity[]): Observable<UnitMemberQualificationResponseEntity[]> {
    return this.dwOrmDataService.saveEntityCollection(responses, false, false);
  }

  private loadDefinitions(): Observable<UnitMemberQualificationTypeEntity[]> {
    const query = AppMetaData.UnitMemberQualificationType.CreateQueryBuilder();

    query.addFilterAnd(filters => filters.Equal(
      attribute => attribute.ReferenceStatusId,
      this.activeReferenceStatusId
    ));
    query.addOrderBy(attribute => attribute.SortOrder);

    return this.dwOrmDataService.executeQuery(query);
  }

  private loadOptions(): Observable<UnitMemberQualificationOptionEntity[]> {
    const query = AppMetaData.UnitMemberQualificationOption.CreateQueryBuilder();

    query.addFilterAnd(filters => filters.Equal(
      attribute => attribute.ReferenceStatusId,
      this.activeReferenceStatusId
    ));
    query.addOrderBy(attribute => attribute.UnitMemberQualificationTypeId);
    query.addOrderBy(attribute => attribute.SortOrder);

    return this.dwOrmDataService.executeQuery(query);
  }

  private loadResponses(flightSchoolExaminerId: number): Observable<UnitMemberQualificationResponseEntity[]> {
    const query = AppMetaData.UnitMemberQualificationResponse.CreateQueryBuilder();

    query.addFilterAnd(filters => filters.Equal(
      attribute => attribute.FlightSchoolExaminerId,
      flightSchoolExaminerId
    ));

    return this.dwOrmDataService.executeQuery(query);
  }
}
